import { useCallback, useState } from "react";
import LogoMini from "../../../components/icons/LogoMini";
import PlayTriangle from "../../../components/icons/PlayTriangle";
import "../general.scss";
import "./index.scss";
import Popup from "../../../components/Popup";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../../context/DataProvider";
import Loyalty from "../../../assets/img/SolutionsIcons/AgilysysLoyalty&Promotions.svg";
import { Header } from "../../../components/Header";

const LoyaltyFPage = () => {
    const [showVideo, setShowVideo] = useState<boolean>(false);
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    return(
        <div className="page splash loyaltyFPage">
            <div className="page-title"><img src={Loyalty} alt="" /></div>
            <Header />
            <div className="text-blocks">
                <div className="std-text">
                A comprehensive loyalty and promotions management
solution to help operators track guest preferences and craft
a wide variety of programs and offers. Loyalty & Promotions
supports point earning and redemption at every guest
interaction and provides a guest portal for self-service
account management.{'\n\n'}
                </div>
                <div className="std-text">
                The result is increased guest wallet-share through repeat
visits by leveraging guest preferences for targeted
promotions and offers.
                </div>
            </div>
            <div className="play-video" onClick={()=>{
                _logEvent('click', "Solutions - Loyalty & Promotions", "Play Video");
                addFlow("Play Video");
                setShowVideo(true)}}>
                <PlayTriangle />
                Play Video
            </div>
            <img className="img-1" src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/Loyalty1.png"} alt="" />
            <img className="img-2" src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/Loyalty2.png"} alt="" />
            <Popup showPopup={showVideo} setShowPopup={()=>setShowVideo(false)} disableOffClick={true}>
                <>{showVideo && <video 
                autoPlay
                controls
                src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/videos/InteractiveLoyaltyPromotions.mp4"} />}</>
            </Popup>
        </div>
    )
}

export default LoyaltyFPage;